import { Box, Table, TableBody, TableCell, TableHead, TableRow, Theme } from '@mui/material';
import { Category, DefaultMapping } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { getFilteredCategoryIds } from '@synergy/utils';
import { makeStyles } from '@mui/styles';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import * as CategoryActions from '../../../../common/actions/category-actions';
import { CategoryMappingRow } from './category-mapping-row';
import { useAppSelector } from '../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../store/use-thunk-dispatch';

const useStyles = makeStyles((theme: Theme) => ({
    table: {
        backgroundColor: '#FFF',

        // No fixed row heights: the theme sets the density, the content the rest.
        '& th': {
            whiteSpace: 'nowrap',
            backgroundColor: theme.palette.background.paper,
        },
        '& th:first-child': {
            paddingLeft: theme.spacing(9),
        },
        '& th:nth-child(2)': {
            paddingLeft: 24,
        },
        '& td:last-child': {
            paddingRight: 8,
        },
    },
}));

interface CategoriesMappingOverviewTableProps {
    onEdit: (item: DefaultMapping<Category>) => void;
}

export const CategoriesMappingOverviewTable = (props: CategoriesMappingOverviewTableProps) => {
    const classes = useStyles();
    const [searchParams] = useSearchParams();
    const dispatch = useThunkDispatch();
    const categories = useAppSelector(state => state.categories.defaultMappings);

    useEffect(() => {
        dispatch(CategoryActions.fetchCategoriesMapping());
    }, [dispatch]);

    const searchResult = getFilteredCategoryIds(categories, searchParams.get('search'));
    const topCategories = categories.filter(category => category.parentId === undefined);

    return (
        <Box sx={{ mx: theme => theme.general.pageContentSpacing, my: 2, flex: 1, overflow: 'auto' }}>
            <Table className={classes.table} stickyHeader={true}>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <FormattedMessage id={'app.table.column.name'} />
                        </TableCell>
                        <TableCell width={'50%'}>
                            <FormattedMessage id={'app.table.column.mapping'} />
                        </TableCell>
                        <TableCell width={'1%'} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {topCategories.map(category => (
                        <CategoryMappingRow
                            key={category.id}
                            categories={categories}
                            category={category}
                            filterIds={searchResult}
                            depth={0}
                            onEdit={props.onEdit}
                        />
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
};
